<template>
  <div id="app">
    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
      <div class="container-fluid">
        <!-- Brand/Logo -->
        <router-link class="navbar-brand d-flex align-items-center" to="/">
          <img src="@/assets/idws_logo.png" alt="IDWS Logo" height="80" width="230" class="me-3">
        </router-link>

        <!-- Mobile Toggle -->
        <button class="navbar-toggler" type="button" @click="toggleMobileNav">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Navigation Links -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" to="/" exact-active-class="active">
                <!-- <SvgIcon name="home" size="sm" color="current" class="me-2" /> -->
                Home
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" to="/agenda" active-class="active">
                <!-- <SvgIcon name="calendar" size="sm" color="current" class="me-2" /> -->
                Agenda
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" to="/speakers" active-class="active">
                <!-- <SvgIcon name="users" size="sm" color="current" class="me-2" /> -->
                Speakers
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" to="/exhibition" active-class="active">
                <!-- <SvgIcon name="building" size="sm" color="current" class="me-2" /> -->
                Exhibition
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" to="/journey" active-class="active">
                <!-- <SvgIcon name="airplane" size="sm" color="current" class="me-2" /> -->
                Journey
              </router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="eventsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <!-- <SvgIcon name="calendar" size="sm" color="current" class="me-2" /> -->
                Events
              </a>
              <ul class="dropdown-menu" aria-labelledby="eventsDropdown">
                <li><router-link class="dropdown-item" to="/events/idws-2025">IDWS 2025</router-link></li>
                <li><router-link class="dropdown-item" to="/events/idws-2026">IDWS 2026</router-link></li>
              </ul>
            </li>
            <li class="nav-item ms-3">
              <router-link class="btn btn-gradient-primary nav-cta-btn" to="/registration" active-class="active">
                <SvgIcon name="users" size="sm" color="white" class="me-2" />
                Register
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="footer mt-5">
      <div class="container">
        <div class="row">
          <!-- Contact Information -->
          <div class="col-lg-4 mb-4">
            <h6 class="footer-heading mb-3">
              <SvgIcon name="email" size="md" color="primary" class="me-2" />
              Contact
            </h6>
            <div class="footer-links">
              <a
                href="mailto:register@digitalworkplacesummit.org?subject=IDWS 2026 Registration Inquiry"
                class="footer-contact-link"
              >
                <SvgIcon name="email" size="sm" color="muted" class="me-2" />
                register@digitalworkplacesummit.org
              </a>
              <a
                href="https://www.digitalworkplacesummit.org"
                target="_blank"
                rel="noopener noreferrer"
                class="footer-contact-link"
              >
                <SvgIcon name="globe" size="sm" color="muted" class="me-2" />
                www.digitalworkplacesummit.org
              </a>
              <a
                href="tel:+255745004005"
                class="footer-contact-link"
              >
                <SvgIcon name="phone" size="sm" color="muted" class="me-2" />
                +255 745 004 005
              </a>
            </div>
          </div>

          <!-- Event Details -->
          <div class="col-lg-4 mb-4">
            <h6 class="footer-heading mb-3">
              <SvgIcon name="calendar" size="md" color="success" class="me-2" />
              Event Details
            </h6>
            <div class="footer-links">
              <div class="footer-contact-link">
                <SvgIcon name="calendar" size="sm" color="muted" class="me-2" />
                <strong>25th - 27th February 2026</strong>
              </div>
              <div class="footer-contact-link">
                <SvgIcon name="building" size="sm" color="muted" class="me-2" />
                Golden Tulip Zanzibar Airport Hotel
              </div>
              <div class="footer-contact-link">
                <SvgIcon name="location" size="sm" color="muted" class="me-2" />
                Zanzibar, Tanzania
              </div>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="col-lg-4 mb-4">
            <h6 class="footer-heading mb-3">
              <SvgIcon name="link" size="md" color="warning" class="me-2" />
              Quick Links
            </h6>
            <div class="footer-links">
              <!-- <router-link to="/agenda" class="footer-nav-link">
                <SvgIcon name="calendar" size="sm" color="current" class="me-2" />
                View Agenda
              </router-link> -->
              <router-link to="/registration" class="footer-nav-link">
                <SvgIcon name="users" size="sm" color="current" class="me-2" />
                Register Now
              </router-link>
              <router-link to="/journey" class="footer-nav-link">
                <SvgIcon name="airplane" size="sm" color="current" class="me-2" />
                Travel
              </router-link>
              <router-link to="/exhibition" class="footer-nav-link">
                <SvgIcon name="building" size="sm" color="current" class="me-2" />
                Partnership
              </router-link>
              <a
                href="https://visa.immigration.go.tz/"
                target="_blank"
                rel="noopener noreferrer"
                class="footer-nav-link"
              >
                <SvgIcon name="globe" size="sm" color="current" class="me-2" />
                VISA
              </a>
              <a
                href="https://inbound.visitzanzibar.go.tz/"
                target="_blank"
                rel="noopener noreferrer"
                class="footer-nav-link"
              >
                <SvgIcon name="location" size="sm" color="current" class="me-2" />
                Visit Zanzibar
              </a>
            </div>
          </div>
        </div>

        <hr class="border-secondary my-4">

        <!-- Powered By -->
        <div class="row align-items-center">
          <div class="col-12">
            <div class="powered-by-logos">
              <div class="ministry-group">
                <a href="https://www.ikuluzanzibar.go.tz/" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/zanzibar_logo.png" alt="Zanzibar Logo" class="partner-logo" />
                </a>
                <div class="separator-line"></div>
                <a href="https://www.mawasilianosmz.go.tz/" target="_blank" rel="noopener noreferrer" class="ministry-link">
                  <div class="ministry-text">
                    <span class="ministry-line1">MINISTRY OF COMMUNICATION,</span>
                    <span class="ministry-line2">INFORMATION TECHNOLOGY AND</span>
                    <span class="ministry-line3">INNOVATION</span>
                  </div>
                </a>
              </div>
              <a href="https://thrapa.or.tz/" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/thrapa_logo.png" alt="THRAPA Logo" class="partner-logo" />
              </a>
              <a href="https://wec2026.acsess.org/" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/World_Employment_Confederation-logo.png" alt="World Employment Confederation" class="partner-logo" />
              </a>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <div class="copyright-text">
              © 2025 IDWS. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'

export default {
  name: 'App',
  components: {
    SvgIcon
  },
  mounted() {
    // Close mobile navbar when clicking on nav links
    this.setupMobileNavClose()
  },
  beforeUnmount() {
    // Clean up event listeners to prevent memory leaks
    if (this.outsideClickHandler) {
      document.removeEventListener('click', this.outsideClickHandler)
    }
  },
  methods: {
    toggleMobileNav() {
      const navbarCollapse = document.getElementById('navbarNav')

      if (navbarCollapse) {
        // Check if navbar is currently open
        const isOpen = navbarCollapse.classList.contains('show')

        if (isOpen) {
          this.closeMobileNav()
        } else {
          this.openMobileNav()
        }
      }
    },
    closeMobileNav() {
      const navbarCollapse = document.getElementById('navbarNav')
      const navbarToggler = document.querySelector('.navbar-toggler')

      if (navbarCollapse && navbarToggler) {
        navbarCollapse.classList.remove('show')
        navbarToggler.classList.add('collapsed')
        navbarToggler.setAttribute('aria-expanded', 'false')
      }
    },
    openMobileNav() {
      const navbarCollapse = document.getElementById('navbarNav')
      const navbarToggler = document.querySelector('.navbar-toggler')

      if (navbarCollapse && navbarToggler) {
        navbarCollapse.classList.add('show')
        navbarToggler.classList.remove('collapsed')
        navbarToggler.setAttribute('aria-expanded', 'true')
      }
    },
    setupMobileNavClose() {
      // Get all nav links, dropdown items, and register button
      const navLinks = document.querySelectorAll('.navbar-nav .nav-link, .navbar-nav .dropdown-item, .navbar-nav .nav-cta-btn')
      const navbarCollapse = document.getElementById('navbarNav')
      const navbarToggler = document.querySelector('.navbar-toggler')
      const navbar = document.querySelector('.navbar')

      // Close navbar when clicking nav links
      navLinks.forEach(link => {
        link.addEventListener('click', (event) => {
          // Check if it's a dropdown toggle, if so, don't close the navbar
          if (link.classList.contains('dropdown-toggle')) {
            return
          }

          // Check if navbar is currently expanded (mobile view)
          if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            // Direct DOM manipulation instead of calling method
            navbarCollapse.classList.remove('show')
            navbarToggler.classList.add('collapsed')
            navbarToggler.setAttribute('aria-expanded', 'false')
          }
        })
      })

      // Close navbar when clicking outside of it - using arrow function to preserve 'this'
      this.outsideClickHandler = (event) => {
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          // Check if click is outside the navbar
          if (!navbar.contains(event.target)) {
            // Direct DOM manipulation instead of calling method
            navbarCollapse.classList.remove('show')
            navbarToggler.classList.add('collapsed')
            navbarToggler.setAttribute('aria-expanded', 'false')
          }
        }
      }

      document.addEventListener('click', this.outsideClickHandler)

      // Setup dropdown functionality if Bootstrap JS isn't available
      this.setupDropdownFallback()
    },

    setupDropdownFallback() {
      const dropdownToggle = document.getElementById('eventsDropdown')
      const dropdownMenu = dropdownToggle?.nextElementSibling

      if (dropdownToggle && dropdownMenu) {
        dropdownToggle.addEventListener('click', (event) => {
          event.preventDefault()

          // Toggle dropdown visibility
          const isExpanded = dropdownToggle.getAttribute('aria-expanded') === 'true'

          if (isExpanded) {
            dropdownMenu.classList.remove('show')
            dropdownToggle.setAttribute('aria-expanded', 'false')
          } else {
            dropdownMenu.classList.add('show')
            dropdownToggle.setAttribute('aria-expanded', 'true')
          }
        })

        // Close dropdown when clicking outside
        document.addEventListener('click', (event) => {
          if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
            dropdownMenu.classList.remove('show')
            dropdownToggle.setAttribute('aria-expanded', 'false')
          }
        })
      }
    }
  }
}
</script>

<style>
/* Global App Styles */
body {
  margin: 0 !important;
  padding: 0 !important;
}

#app {
  min-height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  padding: 0 !important;
}

main {
  flex: 1 !important;
  margin: 0 !important;
  padding: 0 !important;
}

.main-content {
  /* Default padding for non-home pages */
  padding-top: 80px !important;
  margin: 0 !important;
}

/* Remove padding for home page to allow hero overlap */
.home .main-content {
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
}

.home {
  margin: 0 !important;
  padding: 0 !important;
}

/* Enhanced Navigation Styles */
.navbar {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(30, 58, 138, 0.1);
  transition: all 0.3s ease;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 1050 !important;
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  margin: 0 !important;
}

.navbar-brand {
  font-weight: 700;
  color: var(--idws-royal-blue) !important;
  transition: all 0.3s ease;
  margin-left: 80px;
}

.navbar-brand:hover {
  transform: scale(1.05);
}

.nav-link {
  font-weight: 500;
  color: var(--idws-text-dark) !important;
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: var(--spacing-sm) var(--spacing-md) !important;
  margin: 0 var(--spacing-xs);
}

.nav-link:hover {
  color: var(--idws-bright-blue) !important;
  background: rgba(37, 99, 235, 0.1);
  transform: translateY(-1px);
}

.nav-link.active {
  color: var(--idws-bright-blue) !important;
  background: var(--idws-blue-bg-light);
  font-weight: 600;
}

.nav-cta-btn {
  border-radius: 25px !important;
  padding: var(--spacing-sm) var(--spacing-lg) !important;
  font-weight: 600;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
}

.nav-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* Enhanced Footer Styles */
.footer {
  background: linear-gradient(135deg, var(--idws-soft-gray) 0%, var(--idws-light-gray) 100%);
  border-top: 2px solid var(--idws-border-gray);
  padding: var(--spacing-4xl) 0 var(--spacing-2xl);
}

.footer-heading {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--idws-text-dark);
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-lg);
  font-family: var(--font-primary);
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.footer-link {
  display: flex;
  align-items: center;
  color: var(--idws-text-muted);
  margin: 0;
  font-size: var(--font-size-base);
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: var(--idws-bright-blue);
  transform: translateX(4px);
}

.footer-contact-link {
  display: flex;
  align-items: center;
  color: var(--idws-text-muted);
  text-decoration: none;
  font-size: var(--font-size-base);
  padding: 3px 0;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 0;
  min-height: 24px;
  line-height: 1.4;
}

.footer-contact-link:hover {
  color: var(--idws-bright-blue);
  text-decoration: none;
  transform: translateX(6px);
  background: rgba(37, 99, 235, 0.05);
  padding-left: var(--spacing-sm);
}

.footer-nav-link {
  display: flex;
  align-items: center;
  color: var(--idws-text-muted);
  text-decoration: none;
  font-size: var(--font-size-base);
  padding: 3px 0;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 0;
  min-height: 24px;
  line-height: 1.4;
}

.footer-nav-link:hover {
  color: var(--idws-bright-blue);
  text-decoration: none;
  transform: translateX(6px);
}

.powered-by-logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xl);
  padding: var(--spacing-lg);
  flex-wrap: wrap;
}

.ministry-group {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.partner-logo {
  height: 80px !important;
  width: auto !important;
  max-width: none !important;
  transition: all 0.3s ease;
  object-fit: contain;
}

.partner-logo:hover {
  transform: scale(1.1);
}

.separator-line {
  width: 2px;
  height: 60px;
  background-color: var(--idws-royal-blue);
  margin: 0;
}

.ministry-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  font-family: var(--font-secondary);
  font-weight: 700;
  color: var(--idws-royal-blue);
  line-height: 1.2;
  min-width: 280px;
  max-width: 280px;
}

.ministry-line1 {
  font-size: 13px;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
}

.ministry-line2 {
  font-size: 13px;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
}

.ministry-line3 {
  font-size: 13px;
  letter-spacing: 0.3px;
  font-weight: 700;
}

.ministry-link {
  text-decoration: none;
  transition: all 0.3s ease;
}

.ministry-link:hover {
  text-decoration: none;
  transform: scale(1.05);
}

.ministry-link:hover .ministry-text {
  color: var(--idws-bright-blue);
}

.copyright-text {
  color: var(--idws-text-muted);
  font-size: var(--font-size-base);
  font-weight: 500;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.copyright-text:hover {
  opacity: 1;
}

/* Smooth page transitions */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

/* Mobile Navigation Toggler */
.navbar-toggler {
  border: 1px solid var(--idws-bright-blue);
  padding: 6px 8px;
  border-radius: 6px;
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.25);
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%232563eb' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

/* Hide navbar text on mobile */
.navbar-text-desktop {
  display: inline;
}

/* Enhanced Dropdown Styles */
.dropdown-menu {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(37, 99, 235, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  margin-top: 8px;
  padding: var(--spacing-sm);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  color: var(--idws-text-dark);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 2px 0;
}

.dropdown-item:hover {
  background: var(--idws-blue-bg-light);
  color: var(--idws-bright-blue);
  transform: translateX(4px);
}

.dropdown-item.active {
  background: var(--idws-bright-blue);
  color: white;
}

.dropdown-toggle::after {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.dropdown.show .dropdown-toggle::after {
  transform: rotate(180deg);
}

/* Responsive Navigation */
@media (max-width: 768px) {
  .navbar-text-desktop {
    display: none;
  }

  .navbar-brand {
    margin-left: 0 !important;
  }

  .navbar-brand img {
    height: 50px !important;
    width: 100px !important;
    max-width: 120px !important;
  }

  .navbar-collapse {
    background: white;
    margin-top: var(--spacing-md);
    padding: var(--spacing-md);
    border-radius: 12px;
    box-shadow: var(--shadow-md);
    border: 1px solid var(--idws-border-gray);
  }

  .nav-link {
    margin: var(--spacing-xs) 0;
    padding: var(--spacing-md) !important;
  }

  .nav-cta-btn {
    margin-top: var(--spacing-md);
    text-align: center;
    width: 100%;
  }

  .footer-heading {
    font-size: var(--font-size-base);
    margin-bottom: var(--spacing-md);
  }

  .powered-by-logos {
    flex-direction: column;
    gap: var(--spacing-md);
    padding: var(--spacing-md);
  }

  .ministry-group {
    flex-direction: row;
    gap: var(--spacing-xs);
    align-items: center;
    justify-content: center;
  }

  .partner-logo {
    height: 60px !important;
  }

  .separator-line {
    width: 2px;
    height: 40px;
    margin: 0;
  }

  .ministry-text {
    min-width: auto;
    max-width: 200px;
    margin: 0;
    align-items: flex-start;
    text-align: left;
  }

  .ministry-line1,
  .ministry-line2,
  .ministry-line3 {
    font-size: 11px;
  }
}
</style>
